import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { DocumentCommunicationStore } from '../stores';

export const useDocumentCommunicationStore = () => useContext<{
  documentCommunicationStore: DocumentCommunicationStore
}>(StoreContext);
